import {
  Heart, Brain, Baby, Eye, Bone, Stethoscope, Activity, Smile, Scan, Pill, Syringe, Microscope,
  type LucideIcon,
} from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
  Heart,
  Brain,
  Baby,
  Eye,
  Bone,
  Stethoscope,
  Activity,
  Smile,
  Scan,
  Pill,
  Syringe,
  Microscope,
};

export function getDepartmentIcon(name: string): LucideIcon {
  return iconMap[name] ?? Stethoscope;
}
